import { createSelector } from 'reselect';
import { AnyStateWithRefund } from '../types';

export const getRefundInfoState = (state: AnyStateWithRefund) => state.refund.refundInfo;

export const getСonfirmationDocsAreRequired = createSelector(
	getRefundInfoState,
	refundInfo => refundInfo?.confirmationDocsAreRequired
);

export const getUnvoluntaryReasons = createSelector(
	getRefundInfoState,
	refundInfo => refundInfo?.unvoluntaryReasonsInfo || []
);
export const getPrices = createSelector(getRefundInfoState, refundInfo => refundInfo?.prices);

export const getSeatReleaseMode = createSelector(getRefundInfoState, refundInfo => refundInfo?.seatReleaseMode);

export const getNasServices = createSelector(getRefundInfoState, refundInfo => refundInfo?.additionalServices?.nas);
